import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EQuestionnaireStatus } from 'src/app/models/questionnaireGrid.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { EApprovalStatus } from 'src/app/models/approval.model';

@Component({
    selector: 'que-questionnaire-status',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './questionnaire-status.component.html',
    styleUrls: ['./questionnaire-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionnaireStatusComponent {
enumQStatus=EQuestionnaireStatus;
enumApprovalStatus=EApprovalStatus;

@Input() status?:EQuestionnaireStatus
@Input() statusApproval?:EApprovalStatus
@Input() countAnswered?:number = 12
@Input() countAllRecipients?:number = 14
}
